Ext.ns('mx.app.widget');

mx.app.widget.Audit = Ext.extend(Ext.Window, {
    id: 'auditWindow',
    modal: true,
    width: '90%',
    height: 500,
    layout: 'border',
    constrain: true,
    resizable: true,
    border: false,
    title: 'History',
    buttonAlign: 'right',
    pagingSize: 1000,

    labels: {
        cancel: 'Cancel',
        display_changes: 'Displaying changes {0} - {1} of {2}',
        display_empty: 'No changes to display',
        history_of_changing: 'History of changing',
        changed_values: 'Changed values',
        property: 'Property',
        new_value: 'New value',
        filter: 'Filter',
        user_name: 'User name',
        modification_date: 'Modification date',
        action_type: 'Action',
        action_create: 'Create',
        action_update: 'Update',
        action_delete: 'Delete',
        unknown: 'Unknown',
        show_range: 'Show',
    },

    handlers: {
        cancelClick: function() {
            this.close();
        },

        actionRenderer: function(val) {
            switch (val) {
                case 0:
                    return '<span style="color:green;">' + this.labels.action_create + '</span>';
                case 1:
                    return '<span style="color:black;">' + this.labels.action_update + '</span>';
                case 2:
                    return '<span style="color:red;">' + this.labels.action_delete + '</span>';
                default:
                    return this.labels.unknown;
            }
        },

        dateRenderer: function(v) {
            var sb;
            if (window.MXBT && MXBT.getDateFormat) {
                sb = v.dateFormat(MXBT.getDateFormat('fulldate'));
            } else {
                sb = v.dateFormat('d/m/Y');
            }
            return sb + '&nbsp;&nbsp;&nbsp;<b>' + Ext.util.Format.date(v, 'H:i:s') + '</b>';
        },

        unescapeAuditDescription: function(s) {
            var index = s.indexOf('|');

            if (index == -1) {
                return s;
            }

            var sb = '';
            var index2 = 0;

            do {
                sb += s.substring(index2, index);
                var c = s.charAt(++index);
                switch (c) {
                    case '|':
                        sb += '|';
                        break;
                    case 'w':
                        sb += '~';
                        break;
                    case 'c':
                        sb += '=';
                        break;
                    default:
                        alert('Invalid unescape operation! ' + s);
                        return '';
                }
                index2 = ++index;
                index = s.indexOf('|', index);
            } while (index != -1);
            sb += s.substring(index2);
            return sb;
        },
    },

    initComponent: function() {
        this.title = MXBT.loc('mx.app.widget.Audit', 'history_of_changing');

        var thiz = this;

        mx.app.widget.Audit.superclass.initComponent.apply(this, arguments);
        var timeWidth = 80;
        var dateTimeWidth = 165;

        var historyRangeStart;
        var historyRangeEnd;

        if (window.MXBT && MXBT.getDateFormat) {
            historyRangeStart = new Ext.ux.form.DateTime({
                xtype: 'xdatetime',
                id: 'historyRangeStart',
                timeFormat: MXBT.getDateFormat('time'),
                timeWidth: timeWidth,
                width: dateTimeWidth,
                timeConfig: {
                    altFormats: MXBT.getDateFormat('time', 'alt'),
                    allowBlank: false,
                    emptyText: MXBT.getDateFormat('time', 'hint'),
                },
                dateFormat: MXBT.getDateFormat('fulldate'),
                dateConfig: {
                    altFormats: MXBT.getDateFormat('fulldate', 'alt'),
                    allowBlank: false,
                    emptyText: MXBT.getDateFormat('fulldate', 'hint'),
                },
                endDateField: 'historyRangeEnd',
                value: new Date().clearTime(),
            });

            historyRangeEnd = new Ext.ux.form.DateTime({
                xtype: 'xdatetime',
                id: 'historyRangeEnd',
                timeFormat: MXBT.getDateFormat('time'),
                timeWidth: timeWidth,
                width: dateTimeWidth,
                timeConfig: {
                    altFormats: MXBT.getDateFormat('time', 'alt'),
                    allowBlank: false,
                    emptyText: MXBT.getDateFormat('time', 'hint'),
                },
                dateFormat: MXBT.getDateFormat('fulldate'),
                dateConfig: {
                    altFormats: MXBT.getDateFormat('fulldate', 'alt'),
                    allowBlank: false,
                    emptyText: MXBT.getDateFormat('fulldate', 'hint'),
                },
                startDateField: 'historyRangeStart',
                value: new Date()
                    .clearTime()
                    .add(Date.DAY, 1)
                    .add(Date.MINUTE, -1),
            });
        } else {
            //default datetime format
            historyRangeStart = new Ext.ux.form.DateTime({
                xtype: 'xdatetime',
                id: 'historyRangeStart',
                timeWidth: timeWidth,
                width: dateTimeWidth,
                endDateField: 'historyRangeEnd',
                value: new Date().clearTime(),
            });

            historyRangeEnd = new Ext.ux.form.DateTime({
                xtype: 'xdatetime',
                id: 'historyRangeEnd',
                timeWidth: timeWidth,
                width: dateTimeWidth,
                startDateField: 'historyRangeStart',
                value: new Date()
                    .clearTime()
                    .add(Date.DAY, 1)
                    .add(Date.MINUTE, -1),
            });
        }

        var cloneTime = function(v) {
            //cloned Date must be current date,
            // because by 'validate()' in TimeField minValue or maxValue compared with (current Date + TimeField.value)
            var val = new Date();
            val.setHours(v.getHours());
            val.setMinutes(v.getMinutes());
            val.setSeconds(v.getSeconds());
            val.setMilliseconds(v.getMilliseconds());
            return val;
        };

        var datetimerange = function(field, val, startValue) {
            var v = field.getValue();
            if (!v) {
                return;
            }
            var t = true;
            if (t && field.startDateField) {
                var start = Ext.getCmp(field.startDateField);
                start.df.setMaxValue(v.clearTime(true));
                if (
                    start.df.getValue() &&
                    field.df.getValue() &&
                    start.df.getValue().getTime() == field.df.getValue().getTime()
                ) {
                    start.tf.maxValue = cloneTime(v);
                } else {
                    start.tf.maxValue = null;
                    field.tf.minValue = null;
                }
                field.tf.validate();
                start.validate();
            } else if (t && field.endDateField) {
                var end = Ext.getCmp(field.endDateField);
                end.df.setMinValue(v.clearTime(true));
                if (
                    end.df.getValue() &&
                    field.df.getValue() &&
                    end.df.getValue().getTime() == field.df.getValue().getTime()
                ) {
                    end.tf.minValue = cloneTime(v);
                } else {
                    end.tf.minValue = null;
                    field.tf.maxValue = null;
                }
                field.tf.validate();
                end.validate();
            }
        };

        historyRangeEnd.on('change', datetimerange);
        historyRangeStart.on('change', datetimerange);

        var showHistory = function() {
            if (historyRangeStart.isValid() && historyRangeEnd.isValid()) {
                var grid_store = Ext.StoreMgr.lookup('audit');
                grid_store.baseParams['startDate'] = Ext.util.Format.date(
                    historyRangeStart.getValue(),
                    'd/m/Y H:i:s O'
                );
                grid_store.baseParams['endDate'] = Ext.util.Format.date(historyRangeEnd.getValue(), 'd/m/Y H:i:s O');
                grid_store.load({params: {start: 0, limit: this.pagingSize}});
            }
        };

        var store = Ext.StoreMgr.lookup('audit');
        if (this.entityIds && this.entityClasses) {
            store.baseParams['entityIds'] = this.entityIds;
            store.baseParams['entityClasses'] = this.entityClasses;
        } else {
            alert('There are undefined entity ids or entity class names!');
            return;
        }

        if (this.attributes) {
            store.baseParams['attributes'] = this.attributes;
        }

        var historyGrid = new Ext.grid.GridPanel({
            store: store,
            columns: [
                {id: 'id', header: this.labels.user_name, width: 130, sortable: true, dataIndex: 'user_name'},
                {
                    header: this.labels.modification_date,
                    width: 150,
                    sortable: true,
                    renderer: this.handlers.dateRenderer,
                    dataIndex: 'modification_date',
                },
                {
                    header: this.labels.action_type,
                    width: 70,
                    sortable: false,
                    renderer: this.handlers.actionRenderer.createDelegate(this),
                    dataIndex: 'action_type',
                },
            ],
            sm: new Ext.grid.RowSelectionModel({singleSelect: true}),
            title: this.labels.history_of_changing,
            autoExpandColumn: 'user_name',
            width: 500,
            split: true,
            viewConfig: {forceFit: true},
            region: 'west',
            tbar: new Ext.Toolbar({
                items: [
                    historyRangeStart,
                    {
                        text: ' &mdash; ',
                    },
                    historyRangeEnd,
                    new Ext.Button({text: this.labels.show_range, handler: showHistory, scope: this}),
                ],
            }),
            bbar: new Ext.PagingToolbar({
                pageSize: this.pagingSize,
                store: store,
                displayInfo: true,
                displayMsg: this.labels.display_changes,
                emptyMsg: this.labels.display_empty,
            }),
        });

        var valuesGrid = new Ext.grid.GridPanel({
            store: new Ext.data.SimpleStore({
                id: 'history_values_store',
                fields: [{name: 'property'}, {name: 'newvalue'}],
                sortInfo: {
                    field: 'property',
                    direction: 'ASC',
                },
            }),
            columns: [
                {
                    id: 'property',
                    header: this.labels.property,
                    width: 150,
                    sortable: true,
                    dataIndex: 'property',
                    renderer: function(value) {
                        var v = value.split('/');
                        if (v.length == 2) {
                            return MXBT.loc('mx.app.core.auditProperties.' + v[0], v[1]) || v[1];
                        } else {
                            return value;
                        }
                    },
                },
                {header: this.labels.new_value, width: 450, sortable: true, dataIndex: 'newvalue'},
            ],
            title: this.labels.changed_values,
            autoExpandColumn: 'property',
            viewConfig: {forceFit: true},
            region: 'center',
        });

        /*valuesGrid.getSelectionModel().on('rowselect',
                function(sm, rowIdx, r) {
                    var newvalue = r.get('newvalue');
                    newvalue = newvalue.replaceAll(",", ", ");
                    alert(newvalue);
                }
        );*/

        historyGrid.getSelectionModel().on(
            'rowselect',
            function(sm, rowIdx, r) {
                var pairs = r.get('description').split('~');
                var store = [];
                for (var i = 0; i < pairs.length; i++) {
                    store[i] = pairs[i].split('=');
                    store[i][0] = r.get('entity_name') + '/' + store[i][0];
                    var propertyValue = this.handlers.unescapeAuditDescription(store[i][1]);
                    if (propertyValue == 'null') {
                        propertyValue = '';
                    }
                    store[i][1] = propertyValue;
                }
                Ext.StoreMgr.lookup('history_values_store').loadData(store);
            }.createDelegate(this)
        );

        store.on('load', function(store, records, options) {
            if (records.length > 0) {
                historyGrid.getSelectionModel().selectRow(0, false);
            } else {
                Ext.StoreMgr.lookup('history_values_store').removeAll();
            }
        });

        this.add(historyGrid);
        this.add(valuesGrid);

        this.addButton({text: this.labels.cancel}, this.handlers.cancelClick, this);
        this.on('show', showHistory);
        this.on('beforeclose', function(p) {
            Ext.StoreMgr.lookup('audit').removeAll();
            return true;
        });
    },
});
